<template>
  <div class="rk-section">
    <MoreTitle v-if="!showFooter" title="ETF成分股" @click="goPage" />
    <RkTable :data="memberList" :loading="loading" :finished="finished" :show-footer="showFooter">
      <RkTableColumn prop="symbol" label="代码" :width="`${postcssPatch(80)}`" align="left">
        <template #default="{ row }">{{ $digitjs(row.symbol).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="name" label="名称" align="left">
        <template #default="{ row }">{{ $digitjs(row.name).isNull() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="shareholdings" label="持有数量" :width="`${postcssPatch(80)}`">
        <template #default="{ row }">{{ $digitjs(row.shareholdings).convert() }}</template>
      </RkTableColumn>
      <RkTableColumn prop="shareholdingsRate" label="占比" :width="`${postcssPatch(80)}`">
        <template #default="{ row }">{{ $digitjs(row.shareholdingsRate).unit('%').rounded() }}</template>
      </RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
import { postcssPatch } from '@/utils/postcssPatch'

export default {
  props: {
    showFooter: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number,
      default: 10000
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      memberList: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    }
  },
  created() {
    this.getMemberList()
  },
  methods: {
    postcssPatch,
    goPage() {
      this.$router.push({
        path: '/etf/constituent',
        query: {
          symbol: this.$route.query.symbol
        }
      })
    },
    async getMemberList() {
      this.loading = true
      const res = await this.$post(this.$api.sdk[this.market] + '/etf/constituent', {
        pageNum: 1,
        pageSize: this.total,
        sortField: 'changeRate',
        sortType: 1,
        symbol: this.symbol
      })
      this.memberList =
        res.body?.list?.sort((a, b) => {
          return b.shareholdings - a.shareholdings
        }) ?? []
      this.finished = true
      this.loading = false
    }
  }
}
</script>
